import './kategoriaAktEu.scss';
import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
  Col, FormGroup, Label, LoaderButton, Row, Select,
} from 'idsk-react-components';
import { BackButton } from 'slovlex-idsk-react-components';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import routes from '../../../routing/routes';
import { useClient } from '../../../context/ClientStatusContext';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import { KategoriaEnum, kategoriaNazov } from '../../../model/pracovnyKrok/Kategoria';
import { changeKategoria } from '../../../client/pracovnyKrok/kategoriaAktEuClient';
import LegislativnyMaterialDetail from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
}

const KategoriaAktEu = ({ materialDetail }: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const {
    wrapClient: changeKategoriaClient,
    status: changeKategoriaStatus,
  } = useClient(changeKategoria);
  const { displaySuccess } = useSuccessMessageContext();
  const navigate = useNavigate();
  const [kategoria, setKategoria] = useState(materialDetail.kategoriaAktu?.hodnota);
  const { getFieldErrorMessage, clearFieldErrorMessage } = useFieldErrorMessages();

  const changeKategoriaClick = async (): Promise<void> => {
    await changeKategoriaClient(type, year, index, kategoria);
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <div className="kategoria-akt-eu">
      <FormGroup error={!!getFieldErrorMessage('kategoria')}>
        <Row>
          <Col widthDesktop="one-third">
            <Label htmlFor="kategoria">Kategória návrhu aktu EÚ</Label>
          </Col>
        </Row>
        <Row>
          <Col widthDesktop="one-third">
            <Select
              id="kategoria"
              name="kategoria"
              width="full"
              value={kategoria}
              onChange={
                ({ target }) => {
                  setKategoria(target.value);
                  clearFieldErrorMessage('kategoria');
                }
              }
              error={getFieldErrorMessage('kategoria')}
            >
              <option key="Vyberte" value="" hidden>Vyberte</option>
              {(Object.values(KategoriaEnum) && Object.values(KategoriaEnum)?.length > 0) ? (
                <>
                  {Object.values(KategoriaEnum)
                    .map((kategoriaValue) => (
                      <option key={kategoriaValue} value={kategoriaValue}>
                        {kategoriaNazov(kategoriaValue)}
                      </option>
                    ))}
                </>
              ) : (
                <option key="emptyOption" value="emptyOption" disabled>
                  Nenašiel sa žiadny záznam.
                </option>
              )}
            </Select>
          </Col>
        </Row>
      </FormGroup>
      <div className="kategoria-akt-eu__buttons-container">
        <LoaderButton
          size="large"
          className="kategoria-akt-eu__submit-button"
          type="button"
          onClick={changeKategoriaClick}
          loading={changeKategoriaStatus.loading}
          disableOutsideClickWhileLoading
        >Uložiť
        </LoaderButton>
        <BackButton disabled={changeKategoriaStatus?.loading} />
      </div>
    </div>
  );
};

export default KategoriaAktEu;
